angular.module('rjmNg.directives').directive "quickbooksConnectionEditor", [
  () ->
    restrict: "E"
    templateUrl: "connectionEditors/quickbooks.html"
    replace: true
    controllerAs: 'view'
    scope: {}
    controller: [
      "$clientAppUrl"
      "$url"
      "$routeParams"
      "$window"
      "InputConnections"
      "Integrations"
      "notification"
      (
        $clientAppUrl
        $url
        $routeParams
        $window
        InputConnections
        Integrations
        notification
      ) ->
        view = @
        view.connectionsPageUrl = $clientAppUrl('/settings/connection/')
        view.loading = false
        view.quickbooksLink = ''

        _connectionType = 'quickbooks';
        _defaultConfig = 
          id: null
          name: _connectionType
          type: _connectionType
          properties: {}
          credentials: {}

        _IntegrationsInstance = Integrations($routeParams.clientId)
        _InputConnectionsInstance = InputConnections($routeParams.clientId)

        _handleError = (message) ->
          notification.clear("global")
          notification.error("Something went wrong.", message, "global")

        _handleSuccess = (message) ->
          notification.clear("global")
          notification.success("Quickbooks integration saved.", message, "global")

        view.connect = () ->
          view.connection = _defaultConfig
          view.loading = true;
          _InputConnectionsInstance.save(view.connection).then((success) ->
            view.connection = success
            _IntegrationsInstance.oauth2Authorize(view.connection).then((response) ->
              view.quickbooksLink = response.authorize_url
              $window.location.href = response.authorize_url
            , (error) -> 
              _handleError("An error occurred while trying to authorize this connection. Please try again.")
            )
          ,(error) ->
            _handleError("An error occurred while saving this integration. Please try again.")
          ).finally(() ->
            view.loading = false
          )
        
        view.reauth = () ->
          view.loading = true
          _IntegrationsInstance.oauth2Authorize(view.connection).then((response) ->
            view.quickbooksLink = response.authorize_url
            $window.location.href = response.authorize_url
          , (error) -> 
            _handleError("An error occured trying to re-authorize your integration.  Please try again.")
          ).finally(() ->
            view.loading = false
          )

        view.$postLink = () ->
          if($routeParams.error)
                _handleError("An error occurred while saving this integration. Please try again.")
          if($routeParams.saved)
                _handleSuccess("Connected to Quickbooks successfully!")
          if($routeParams.connectionId)
            view.loading = true
            _InputConnectionsInstance.getByMetaId($routeParams.connectionId, false).then((success)->
              view.connection = success
            ,(error)->
              _handleError('An error occurred while loading this connection.');
            ).finally(() ->
              view.loading = false
            )
          else
            view.connection = _defaultConfig

        view
    ]
]
